/** данные пользователя */
export const setUser = (user) => {
  return {type: 'SET_USER_USER_DATA', payload:user};
};
/** отдельно имя пользователя */
export const setUserName = (userName) => {
  return {type: 'SET_USER_USER_NAME', payload:userName};
};
/**Статус залогиненности */
export const setIsLoggedIn = (isLoggedIn) => {
  return {type: 'SET_USER_LOGIN_STATUS', payload:isLoggedIn};
};
/**Настройки пользователя */
export const setUserSettings = (settings) => {
  return {type: 'SET_USER_SETTINGS', payload:settings};
};
/**Настройки пользователя */
export const setUserRights = (rights) => {
  return {type: 'SET_USER_RIGHTS', payload:rights};
};
/**Ролевое имя пользователя (не путать с называнием роли) - это строка, которая отражает и имя и роль*/
export const setUserRolename = (rolename) => {
  return {type: 'SET_USER_ROLENAME', payload:rolename};
};
/**Название роли пользователя*/
export const setUserRole = (role) => {
  return {type: 'SET_USER_ROLE', payload:role};
};
/**Сброс всего состояния редакса (кроме сервисов) */
export const makeReset = () => {
  return {type: 'RESET'};
};
